<template>
	<button @click="handleClick" class="btn btn--secondary" :class="{ 'is-loading': isLoading }" :disabled="isLoading" :title="this.title">
		<slot> Add to Basket </slot>
	</button>
</template>

<script>
import { basket } from "../../helpers/products/basket-store.js";

export default {
	props: {
		itemId: {
			type: String,
			required: true,
		},

		price: {
			type: String,
			required: true,
		},

		title: {
			type: String,
			default: "Add to Basket",
		},
	},

	data() {
		return {
			basket,
			isLoading: false,
			parsedPrice: JSON.parse(this.price),
		};
	},

	methods: {
		handleClick() {
			this.isLoading = true;

			basket.addItem({ id: this.itemId, price: this.parsedPrice }).finally(() => {
				this.isLoading = false;
			});
		},
	},
};
</script>
